import { PopoverOrigin } from '@mui/material';

import {
  colors,
  filterInput,
  fonts,
  label,
  menuItem,
  menuPaper,
} from '../../theme';

const styles = {
  select: {
    ...filterInput,
    width: '100%',
    pl: 0,
    pr: 0,
    '& .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
    '& .MuiSelect-select': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: 0.5,
      height: '100% !important',
      py: 0,
      pl: 1.5,
      pr: '28px !important',
      boxSizing: 'border-box',
    },
    '& .MuiSelect-icon': {
      color: colors.textSecondary,
      right: 6,
    },
    '&.Mui-disabled .MuiSelect-select': {
      WebkitTextFillColor: colors.textSubtle,
    },
  },
  label: {
    ...label,
    fontSize: 10,
    letterSpacing: '0.04em',
    lineHeight: '12px',
  },
  value: {
    fontFamily: fonts.text,
    fontSize: 12.5,
    fontWeight: 500,
    lineHeight: '16px',
    color: colors.text,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  // The menu starts at the left edge of the select (MUI moves it when there is no room).
  menuProps: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    } as PopoverOrigin,
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    } as PopoverOrigin,
    PaperProps: {
      sx: {
        ...menuPaper,
        // A few px between the select and its options.
        mt: 0.75,
        maxHeight: 320,
      },
    },
  },
  // Above the select, every option visible.
  menuPropsUp: {
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'left',
    } as PopoverOrigin,
    transformOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    } as PopoverOrigin,
    PaperProps: {
      sx: {
        ...menuPaper,
        mt: -0.75,
        maxHeight: 'none',
      },
    },
  },
  menuItem,
};

export default styles;
